<script>
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'
import store from '@state/store'
import { cloneDeep, pick } from 'lodash'
import { FULL_ROLE_AGENT_EDIT } from '@utils/helpers'

export default {
  props: {
    type: {
      type: String,
      default: 'add',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    triggerMask: {
      type: Boolean,
      require: false,
    },
    notificationDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      currentUser: store.getters['auth/getCurrentUser'],
      editable: false,
      data: {
        title: '',
        status: '',
        content: '',
        image_url: '',
        image_binary: '',
        link: '',
        tag: '',
      },
      quote: '',
      items: [
        {
          label: 'ID',
          name: 'id',
        },
        {
          label: '引用',
          name: 'quote',
          options: [],
          rules: {
            required: false,
          },
        },
        {
          label: 'ステータス',
          name: 'status',
          rules: {
            required: false,
          },
        },
        {
          label: 'タグ',
          name: 'tag',
          options: [
            {
              label: '',
              value: '',
            },
            {
              label: 'お知らせ',
              value: 'お知らせ',
            },
            {
              label: 'トレーニング',
              value: 'トレーニング',
            },
            {
              label: 'アドバイス',
              value: 'アドバイス',
            },
            {
              label: 'スケジュール',
              value: 'スケジュール',
            },
            {
              label: 'キャンペーン',
              value: 'キャンペーン',
            },
            {
              label: 'クーポン',
              value: 'クーポン',
            },
          ],
          rules: {
            required: false,
          },
        },
        {
          label: 'タイトル',
          name: 'title',
          placeholder: 'タイトルを入力してください',
          rules: {
            required: true,
            max: 255,
          },
        },
        {
          label: '本文',
          name: 'content',
          placeholder: '本文を入力してください',
          rules: {
            required: true,
            max: 1000,
          },
        },
        {
          label: '画像',
          name: 'image_url',
          rules: {
            required: false,
          },
        },
        {
          label: 'URL',
          name: 'link',
          placeholder: '例）https://feelline.jp/',
          rules: {
            required: false,
            max: 2000,
          },
        },
        {
          label: '作成者',
          name: 'created_name',
        },
        {
          label: '更新者',
          name: 'updated_name',
        },
        {
          label: '閲覧数',
          name: 'hits',
        },
        {
          label: 'クリック数',
          name: 'clicks',
        },
        {
          label: '実績期間',
          name: 'start',
          value: '',
        },
      ],
    }
  },
  computed: {
    ...notificationComputed,
    status() {
      const status = this.notificationDetail.status || 0
      const statusList = [
        '配信待ち',
        '配信中',
        '配信終了',
        '無効化',
        '無効化申請中',
      ]
      if (status < 0 || status >= statusList.length) {
        return ''
      }
      return statusList[status]
    },
    add() {
      return this.type === 'add'
    },
    view() {
      return this.type === 'view'
    },
    edit() {
      return this.type === 'edit'
    },
    itemsComputed() {
      return this.items.filter((item) => {
        return (
          (this.add &&
            item.name !== 'status' &&
            item.name !== 'id' &&
            item.name !== 'created_name' &&
            item.name !== 'updated_name' &&
            item.name !== 'hits' &&
            item.name !== 'clicks' &&
            item.name !== 'start') ||
          (this.view &&
            item.name !== 'quote' &&
            item.name !== 'tag' &&
            item.name !== 'title' &&
            item.name !== 'content' &&
            item.name !== 'image_url') ||
          (this.edit &&
            item.name !== 'quote' &&
            item.name !== 'id' &&
            item.name !== 'created_name' &&
            item.name !== 'updated_name' &&
            item.name !== 'hits' &&
            item.name !== 'clicks' &&
            item.name !== 'start')
        )
      })
    },
    quoteOptionComputed() {
      const quotes = this.getQuotes || []
      return quotes.map((quote) => {
        return { label: `[${quote.id}]-${quote.title}`, value: `${quote.id}` }
      })
    },
    isHideEditComputed() {
      return (
        this.add ||
        this.notificationDetail.status !== 0 ||
        !FULL_ROLE_AGENT_EDIT.includes(this.currentUser.level)
      )
    },
  },
  watch: {
    notificationDetail() {
      const data = pick(this.notificationDetail, [
        'id',
        'status',
        'tag',
        'title',
        'content',
        'image_url',
        'image_binary',
        'link',
        'created_name',
        'updated_name',
        'hits',
        'clicks',
        'start',
        'end',
      ])
      this.dataInit = cloneDeep(data)
      this.data = cloneDeep(data)
      this.items.map((item) => {
        if (item.name === 'start') {
          data.start = data.start ? data.start : '-'
          data.end = data.end ? data.end : '-'
          item.value = `${data.start}  ~  ${data.end}`
        }
      })
    },
    data: {
      handler() {
        if (
          this.add &&
          JSON.stringify(this.data) !== JSON.stringify(this.dataInit)
        ) {
          this.$emit('change', this.data)
        }
      },
      deep: true,
    },
    type() {
      if (this.view) {
        this.editable = false
      } else if (this.edit) {
        this.editable = true
      }
    },
  },
  created() {
    if (this.add) {
      const place = 1
      const agentId = this.currentUser?.agent.id
      this.fetchingQuotes({ place, agent_id: agentId })
    }
  },
  methods: {
    ...notificationMethods,
    handleUploadImage(imageBinary) {
      this.data.image_url = ''
      this.data.image_binary = imageBinary
    },
    getStatus(index) {
      const statusList = [
        '配信待ち',
        '配信中',
        '配信終了',
        '無効化',
        '無効化申請中',
      ]
      if (index < 0 || index >= statusList.length) {
        return ''
      }
      return statusList[index]
    },
    toggleEditable() {
      this.editable = !this.editable
      this.$emit('enable:edit', this.editable)
    },
    onClickQuote() {
      const quote = this.quote || this.quoteOptionComputed[0].value
      this.$emit('onClickQuote', parseInt(quote, 10))
    },
  },
}
</script>

<template>
  <div id="notification_agentadmin-basic-info">
    <BaseCardDetail
      title="基本情報"
      form-collapsed
      :errors="errors"
      :trigger-mask="!editable && triggerMask"
      :has-footer="!add && editable"
      @edit="toggleEditable"
      @cancel="toggleEditable"
      @submit="
        () => {
          $emit('edit:notification', data)
        }
      "
    >
      <template v-if="isHideEditComputed" v-slot:header-action>
        <div />
      </template>
      <CRow
        v-for="item in itemsComputed"
        :key="item.key"
        class="d-flex align-items-baseline flex-wrap"
      >
        <CCol sm="3">
          <div class="col-form-label">
            {{ item.label }}
            <span v-if="item.rules && item.rules.required" class="text-danger"
              >*</span
            >
          </div>
        </CCol>
        <CCol sm="9">
          <template v-if="item.name === 'quote'">
            <CRow class="d-flex align-items-baseline flex-wrap">
              <CCol sm="8">
                <BaseSelect
                  :value.sync="quote"
                  :options="quoteOptionComputed"
                />
              </CCol>
              <CCol sm="4">
                <CButton
                  color="dark"
                  variant="outline"
                  class="py-0"
                  @click="onClickQuote"
                >
                  適用
                </CButton>
              </CCol>
            </CRow>
          </template>
          <template v-else-if="item.name === 'tag'">
            <BaseSelect
              :value.sync="data.tag"
              :options="item.options"
              :vee-name="item.name"
              :rules="item.rules"
              :readonly="view"
              :disabled="view"
            />
          </template>
          <template v-else-if="item.name === 'status'">
            <BaseInput
              :value="status"
              :placeholder="item.placeholder"
              :vee-name="item.name"
              :rules="item.rules"
              :readonly="true"
              :disabled="true"
            />
          </template>
          <template
            v-else-if="
              item.name === 'title' ||
                item.name === 'link' ||
                item.name === 'id' ||
                item.name === 'created_name' ||
                item.name === 'updated_name' ||
                item.name === 'hits' ||
                item.name === 'clicks' ||
                item.name === 'start'
            "
          >
            <BaseInput
              v-if="item.name === 'link' && !!view"
              v-model="data[item.name]"
              :vee-name="item.name"
              :rules="item.rules"
              :readonly="view"
            />
            <BaseInput
              v-else-if="item.name === 'start' && !!view"
              v-model="item.value"
              :vee-name="item.name"
              :rules="item.rules"
              :readonly="view"
            />
            <BaseInput
              v-else
              v-model="data[item.name]"
              :placeholder="item.placeholder"
              :vee-name="item.name"
              :rules="item.rules"
              :readonly="view"
            />
          </template>
          <template v-else-if="item.name === 'content'">
            <BaseTextarea
              v-model="data[item.name]"
              :placeholder="item.placeholder"
              :vee-name="item.name"
              :rules="item.rules"
              :readonly="view"
            />
          </template>
          <template v-else-if="item.name === 'image_url'">
            <BaseUploadImage
              :readonly="view"
              :disabled="view"
              :image-url="data[item.name]"
              :image-binary="data['image_binary']"
              @change="handleUploadImage"
            />
          </template>
        </CCol>
      </CRow>
    </BaseCardDetail>
  </div>
</template>
